<template>
	<div class="footer">
		<div class="footer-wrap">
			<p>© 2026 馆陶分类信息网 版权所有 | <a href="https://beian.miit.gov.cn/">冀ICP备2024067900号-2</a></p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Footer'
	}
</script>

<style lang="scss" scoped>
	.footer {
		background: #f5f5f5;
		padding: 20px 0;
		text-align: center;
		color: #666;
		margin-top: 30px;
	}
</style>